export default {
  GET_RETIREMENT_FORECAST_CALCULATION_QUERY: Symbol.for('GET_RETIREMENT_FORECAST_CALCULATION_QUERY'),
  UPDATE_RETIREMENT_FORECAST_CALCULATION_COMMAND: Symbol.for('UPDATE_RETIREMENT_FORECAST_CALCULATION_COMMAND'),
  CREATE_RETIREMENT_FORECAST_CALCULATION_COMMAND: Symbol.for('CREATE_RETIREMENT_FORECAST_CALCULATION_COMMAND'),
  CALCULATE_PROJECTION_COMMAND: Symbol.for('CALCULATE_PROJECTION_COMMAND'),
  RETIREMENT_FORECAST_CALCULATION_REPOSITORY: Symbol.for('RETIREMENT_FORECAST_CALCULATION_REPOSITORY'),
};
